<div class="resumo-ocorrencias-indicadores width-100 height-120 dl-list-inline">
  <div class="container-header">
    <div class="clearfix"></div>
    <div class="title text-center">
      <h2>
        <strong>OCORRÊNCIAS</strong>
      </h2>
    </div>
    <div>
      <!-- Filtros -->
      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle>
        <button type="button" class="btn" ng-click="openPeriodsFilter($event)">
          {{periodo.periodo || (data || history.data | date:'dd/MM/yyyy') || 'Período'}} <span class="caret"></span>
        </button>
      </div>
      <div class="btn-group" uib-dropdown dropdown-append-to-body="true" uib-dropdown-toggle ng-disabled="cultivares.length === 1">
        <button type="button" class="btn" uib-tooltip="{{filters.cultivar.descricao || 'Cultivar'}}" tooltip-append-to-body="true" tooltip-placement="bottom" tooltip-class="tooltip-break-word">
          {{(filters.cultivar.descricao || 'Cultivar') | capitalize | characters:30}} <span class="caret"></span>
        </button>
        <ul class="dropdown-menu-right" uib-dropdown-menu>
          <li ng-show="filters.cultivar">
            <a ng-click="setCultivar(null, $event)" href="#">Todas</a>
          </li>
          <li ng-repeat="cultivar in cultivares | orderBy:'cultivar.descricao' track by cultivar.cultivar.id">
            <a href="#" ng-click="setCultivar(cultivar.cultivar, $event)">{{cultivar.cultivar.descricao | capitalize}}</a>
          </li>
        </ul>
      </div>
      <!-- Fim filtros -->
    </div>
    <div>
      Talhão: <strong>{{(gleba || history.gleba).descricao | capitalize}}</strong>
      <span ng-show="resumoOcorrenciasIndicadores.quantidade_pontos">
        <br>
        Quantidade de Pontos: <strong>{{resumoOcorrenciasIndicadores.quantidade_pontos}}</strong>
        <i class="icon-info text-muted" aria-hidden="true"
           uib-tooltip="São contabilizados somente os pontos feitos em locais distintos."
           tooltip-placement="left" tooltip-append-to-body="true"></i>
      </span>
    </div>
  </div>

  <div class="container-body width-100">
    <p class="text-center" ng-show="!resumoOcorrenciasIndicadores.ocorrencias.length">
      <small>Nenhum registro...</small>
    </p>

    <div class="panel panel-default-agro1" disabled="disabled" ng-repeat="ocorrencia in resumoOcorrenciasIndicadores.ocorrencias track by ocorrencia.id">
      <div class="panel-heading">
        <i agro-icon-historico historico="ocorrencia" class="f-size-22 icon-padding pull-left"></i>
        <h4 class="panel-title">
          {{ocorrencia.descricao | capitalize}}
          <small class="text-italic">
            <br>{{ocorrencia.cientifico}}
          </small>
        </h4>
      </div>
      <div class="panel-body text-muted">
        <dl class="no-margin">
          <dynamic-include object="indicador" template="'views/directives/indicadores_ocorrencias/' + indicador.tipo + '.html'"
                           ng-repeat="indicador in ocorrencia.indicadores track by indicador.id" class="block">
          </dynamic-include>
        </dl>
      </div>
    </div>
  </div>
</div>
